export const TABS = {
  FAVORITES_LIST: 'favorites-list',
  HIGHLY_RATED: 'highly-rated',
  RECENT_PROFESSIONALS: 'recent-professionals',
};